module.exports = __webpack_public_path__ + "img/slide5.97378d16.png";